import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import BusinessTypeAttachments from './BusinessType/attachments';
import GeneralInfoAttachments from './GeneralInfo/attachments';

export interface IBusinessInfoAttachmentsProps {}

export default function BusinessInfoAttachments(
  props: IBusinessInfoAttachmentsProps,
) {
  return (
    <div>
      <DashboardContainerHeader title="Business Info" />
      <BusinessTypeAttachments />
      <GeneralInfoAttachments />
    </div>
  );
}
